import { useEffect } from "react";
import { CheckIcon, CloseIcon, CopyIcon } from "./Icons";
import type { JsonObject } from "../types/json";

interface RawJsonModalProps {
  data: JsonObject;
  copied: boolean;
  onCopy: () => void;
  onClose: () => void;
}

export function RawJsonModal({ data, copied, onCopy, onClose }: RawJsonModalProps) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    document.addEventListener("keydown", handleKeyDown);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#17253a]/55 p-3 backdrop-blur-sm sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="raw-json-title"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div className="flex max-h-[92vh] w-full max-w-5xl flex-col overflow-hidden rounded-[1.75rem] border border-[#dce5ef] bg-white shadow-2xl shadow-[#17253a]/20">
        <header className="flex items-center justify-between gap-4 border-b border-[#dce5ef] px-4 py-4 sm:px-6">
          <div>
            <h2 id="raw-json-title" className="font-semibold text-[#17253a]">
              JSON bruto
            </h2>
            <p className="mt-1 text-xs text-[#6f7f94]">Resposta integral recebida da API.</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onCopy}
              className="button-secondary rounded-xl px-3 py-2 text-sm font-medium"
            >
              {copied ? (
                <span className="inline-flex items-center gap-2 text-[#16835f]">
                  <CheckIcon className="size-4" /> Copiado
                </span>
              ) : (
                <span className="inline-flex items-center gap-2">
                  <CopyIcon className="size-4" /> Copiar
                </span>
              )}
            </button>
            <button
              type="button"
              onClick={onClose}
              aria-label="Fechar visualização do JSON"
              className="button-secondary flex size-10 items-center justify-center rounded-xl"
            >
              <CloseIcon className="size-4" />
            </button>
          </div>
        </header>
        <pre className="min-h-0 flex-1 overflow-auto p-4 font-mono text-xs leading-6 bg-[#f4f7fb] text-[#24364c] sm:p-6">
          {JSON.stringify(data, null, 2)}
        </pre>
      </div>
    </div>
  );
}
